import isNumber from 'lodash/isNumber';
import Icon from 'react-fa';
import StarRatingComponent from 'react-star-rating-component';
const styles = require('./Rating.less') as any;
import { S, purify } from '../../utils'
import { h, span } from 'react-hyperscript-helpers'
// TODO: Ensure accessible
const RenderStarIcon = (index, value, name) => value >= index ? h(Icon, { name: 'star' }) : h(Icon, { name: 'star-o' })
const Rating = ({rating, reviewers, review_count, editable = false, name, classes}) => (
	span(S([styles.Rating, classes]),
		isNumber(rating.personalized || rating.average)
			? [
				h(StarRatingComponent, {
					value: rating.personalized || rating.average,
					starCount: 5,
					starColor: 'blue',
					emptyStarColor: 'darkgrey',
					editing: editable,
					renderStarIcon: RenderStarIcon,
					name: name,
				}),
				`${reviewers} users have contributed ${review_count} reviews`,
			]
			: ['Rate this place!']
	)
)

export default purify(Rating);



// WEBPACK FOOTER //
// ./src/app/components/Rating/index.ts